import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthHttpClientService } from '@service/auth-http-client.service';
import { EventTypesByProductIdsDto } from '@dto/email-products/event-types-by-product-ids.dto';
import { ChatCodesByProductIdsDto } from '@dto/campaign/chat-codes-by-product-ids.dto';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'any',
})
export class ProductService {
  private readonly url: string = environment.tmnBackApi;

  constructor(private readonly http: AuthHttpClientService) {}

  // ---- Email ----
  getEmailEventTypesByProductId(): Observable<{ [productId: string]: string[] }> {
    return this.http.get<EventTypesByProductIdsDto>(`${this.url}/products/emails`).pipe(
      map(response => response.eventTypesByProductId)
    );
  }

  getPublicEmailEventTypesByProductId(): Observable<{ [productId: string]: string[] }> {
    return this.http.get<EventTypesByProductIdsDto>(`${this.url}/products/emails/public`).pipe(
      map(response => response.eventTypesByProductId)
    );
  }

  // ---- SMS ----
  getSmsEventTypesByProductId(): Observable<{ [productId: string]: string[] }> {
    return this.http.get<EventTypesByProductIdsDto>(`${this.url}/products/sms`).pipe(
      map(response => response.eventTypesByProductId)
    );
  }

  // ---- Teams Chat Singles ----
  getChatSingleCodesByProductId(): Observable<{ [productId: string]: string[] }> {
    return this.http.get<ChatCodesByProductIdsDto>(`${this.url}/products/teams/chat-singles`).pipe(
      map(response => response.chatCodesByProductId)
    );
  }

  // ---- Teams Chat Groups ----
  getChatGroupCodesByProductId(): Observable<{ [productId: string]: string[] }> {
    return this.http.get<ChatCodesByProductIdsDto>(`${this.url}/products/teams/chat-groups`).pipe(
      map(response => response.chatCodesByProductId)
    );
  }

  // ---- Teams Channels ----
  getChannelProductIds(): Observable<string[]> {
    return this.http.get<string[]>(`${this.url}/products/teams/channels`);
  }
}
